// extracted by mini-css-extract-plugin
module.exports = {"section":"Cargo_section__du3NN","value":"Cargo_value__atOGV"};